import { Badge, Code } from '@mantine/core';

import classes from './PropertyTable.module.css';

export interface PropertyTableProps {
  data?: object;
}

export function PropertyTable({ data }: PropertyTableProps) {
  return (
    <div className={classes.propertyTable}>
      {data && Object.keys(data).length > 0 ? (
        Object.entries(data).map(
          ([key, value]) =>
            !!key && (
              <div className={classes.property} key={key}>
                <div className={classes.key}>{camelCaseToWords(key)}</div>
                <div className={classes.value}>
                  <PropertyValue value={value} />
                </div>
              </div>
            ),
        )
      ) : (
        <div>
          <span className={classes.nullValue}>(empty object)</span>
        </div>
      )}
    </div>
  );
}

function camelCaseToWords(s: string) {
  const result = s.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

type PropertyValueType = null | undefined | PropertyValueType[] | Date | boolean | string | number;

interface PropertyValueProps {
  value: PropertyValueType;
}

function PropertyValue({ value }: PropertyValueProps) {
  if (value === null || value === undefined || value === '') {
    return <span className={classes.nullValue}>n/a</span>;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return (
        <div className={classes.arrayValue}>
          <span className={classes.nullValue}>(n/a)</span>
        </div>
      );
    }
    return (
      <div className={classes.arrayValue}>
        {value.map((it) => (
          <PropertyValue key={JSON.stringify(it)} value={it} />
        ))}
      </div>
    );
  }

  if (typeof value === 'boolean') {
    return (
      <div className={classes.booleanValue}>
        <Badge color={value ? 'green' : 'red'} variant="light">
          {value.toString()}
        </Badge>
      </div>
    );
  }

  if (value instanceof Date) {
    return (
      <div className={classes.dateValue}>
        <Code>{value.toISOString()}</Code>
      </div>
    );
  }

  if (typeof value === 'number') {
    return (
      <div className={classes.numberValue}>
        <Code>{value.toLocaleString()}</Code>
      </div>
    );
  }

  if (typeof value === 'object') {
    return <PropertyTable data={value} />;
  }

  return <span className={classes.stringValue}>{value.toString()}</span>;
}
